import React from "react";
import { _closeDrawer, _goToItsaWebSite } from "routers/helper";

import { View, TouchableOpacity } from "react-native";
import { Text } from "components";

import { mq } from "utils";
import css from "styles";
import { VERSION, colors, sizes, strings } from "assets/constants";

export default function ItsaLink() {
  return (
    <View
      style={{
        ...css.rRowCenterAlign,
        ...css.centralElements,
        paddingHorizontal: mq(5),
      }}
    >
      <TouchableOpacity
        onPress={() => {
          _closeDrawer();
          setTimeout(_goToItsaWebSite, 500);
        }}
        activeOpacity={sizes.tapOpacity}
        style={{
          ...css.selfCenter,
          ...css.centralElements,
          paddingVertical: mq(5),
        }}
      >
        <Text size={"sm"} align="center">
          {strings.lead} {VERSION.NAME}
        </Text>
        <View style={{ ...css.rRowCenterAlign, marginTop: mq(4) }}>
          <Text size={"xs"}> {strings.developed_by}</Text>
          <Text size={"sm"} color={colors.info}>
            {" "}
            {strings.itsa}
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
}
